/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActualAssetClassExposureResponseViewModel
 */
export interface ActualAssetClassExposureResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    equity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    property?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    bonds?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    cash?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    hedge?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    privateEquity?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    commodities?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    other?: number;
    /**
     * 
     * @type {string}
     * @memberof ActualAssetClassExposureResponseViewModel
     */
    id?: string;
}

/**
 * Check if a given object implements the ActualAssetClassExposureResponseViewModel interface.
 */
export function instanceOfActualAssetClassExposureResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;

    return isInstance;
}

export function ActualAssetClassExposureResponseViewModelFromJSON(json: any): ActualAssetClassExposureResponseViewModel {
    return ActualAssetClassExposureResponseViewModelFromJSONTyped(json, false);
}

export function ActualAssetClassExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActualAssetClassExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'equity': !exists(json, 'Equity') ? undefined : json['Equity'],
        'property': !exists(json, 'Property') ? undefined : json['Property'],
        'bonds': !exists(json, 'Bonds') ? undefined : json['Bonds'],
        'cash': !exists(json, 'Cash') ? undefined : json['Cash'],
        'hedge': !exists(json, 'Hedge') ? undefined : json['Hedge'],
        'privateEquity': !exists(json, 'PrivateEquity') ? undefined : json['PrivateEquity'],
        'commodities': !exists(json, 'Commodities') ? undefined : json['Commodities'],
        'other': !exists(json, 'Other') ? undefined : json['Other'],
        'id': !exists(json, 'Id') ? undefined : json['Id'],
    };
}

export function ActualAssetClassExposureResponseViewModelToJSON(value?: ActualAssetClassExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'Percentage': value.percentage,
        'Equity': value.equity,
        'Property': value.property,
        'Bonds': value.bonds,
        'Cash': value.cash,
        'Hedge': value.hedge,
        'PrivateEquity': value.privateEquity,
        'Commodities': value.commodities,
        'Other': value.other,
        'Id': value.id,
    };
}

